import lazyLoading from './lazyLoading'

export default {
  name: 'HomeNet Visitor',
  path: '/homenet/visitor',
  redirect: '/homenet/visitor/history',
  meta: {
    auth: ['user'],
    icon: 'fas fa-cube',
    expanded: false
  },
  component: lazyLoading('homenet', true),
  children: [
    {
      'name': 'History',
      'path': 'history',
      'meta': {
        'label': 'History'
      },
      'component': lazyLoading('homenet/VisitorHistory')
    }
  ]
}



// WEBPACK FOOTER //
// ./client/store/modules/menu/visitor.js